import {ChangeEvent, InputHTMLAttributes, useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {compressImage} from 'utils/compressImage';
import {DeviceCameraBlock, FileInputLabel, HiddenInput} from './styled';

type Props = {
  onChange: (photo?: Promise<string>) => void;
  facingMode?: InputHTMLAttributes<unknown>['capture'];
};
export const DeviceCamera = ({onChange, facingMode}: Props) => {
  const {t} = useTranslation();
  const handleNativeScreenshot = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      onChange(file ? compressImage(file) : file);
    },
    [onChange],
  );

  return (
    <DeviceCameraBlock>
      <div>{t('camera_errors.experiencing_camera_issues')}</div>
      <FileInputLabel>
        {t('open_devices_camera')}
        <HiddenInput
          type="file"
          accept="image/*"
          capture={facingMode || 'environment'}
          onChange={handleNativeScreenshot}
        />
      </FileInputLabel>
    </DeviceCameraBlock>
  );
};
